import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsOptimizeIssueSecurityLevelSchemeRoute: InvariantJiraRoute = {
	name: 'global-settings-optimize-issue-security-level-scheme',
	path: '/jira/settings/system/performance/issue-security-level-scheme/:schemeId/optimize',
};
